module.exports = "pegasus_template/assets/themelp1/design/100.png";